module.exports = __webpack_public_path__ + "static/media/ftn-danskebank-auth.7ca7016f.svg";